// extracted by mini-css-extract-plugin
module.exports = {"list":"navigation-link-block_list__SG9Mf","heading":"navigation-link-block_heading__YiQIu","link":"navigation-link-block_link__zv3rl"};